export default [
  {
    id: "1",
    title: "Number of Beds Available",
    category: "Beds",
    likes: 4,
    dislikes: 1
  },
  {
    id: "2",
    title: "Number of Covid Vaccines Available",
    category: "Covaxin",
    likes: 2,
    dislikes: 0
  },
  {
    id: "3",
    title: "Number of Patients",
    category: "Positive",
    likes: 3,
    dislikes: 1
  }
];
